import React, { useMemo } from 'react';
import { Card, Table, Typography, Tag } from 'antd';
import { mockSnippets, mockWebsites } from '../Super Admin/mockData';

const { Title, Text } = Typography;

const columns = [
  { title: 'ID', dataIndex: 'id', key: 'id', width: 90 },
  { title: 'Snippet Name', dataIndex: 'name', key: 'name' },
  { title: 'Website', dataIndex: 'website', key: 'website' },
  { title: 'Status', dataIndex: 'status', key: 'status', width: 140, render: (s) => <Tag color={s === 'active' ? 'green' : 'default'}>{s}</Tag> },
];

const ViewerSnippets = () => {
  const websiteMap = useMemo(() => Object.fromEntries(mockWebsites.map(w => [w.id, w.url])), []);
  const dataSource = useMemo(() => mockSnippets.map(s => ({
    key: s.id,
    id: s.id,
    name: s.name,
    website: websiteMap[s.website_id] || '-'
      ,
    status: s.status,
  })), [websiteMap]);

  return (
    <div>
      <Title level={2} style={{ marginBottom: 16 }}>Snippets (View Only)</Title>
      <Card style={{ borderRadius: 14 }}>
        <Text type="secondary">You can view available snippets. Editing is disabled.</Text>
        <Table style={{ marginTop: 12 }} columns={columns} dataSource={dataSource} pagination={{ pageSize: 5 }} />
      </Card>
    </div>
  );
};

export default ViewerSnippets;
